import React from 'react';
import { Stethoscope, Heart, BookOpen } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function TrustBar() {
  const {
    t
  } = useLanguage();
  const badges = [{
    icon: Stethoscope,
    labelEn: 'Bariatric & General Surgery',
    labelEs: 'Cirugía bariátrica y general'
  }, {
    icon: Heart,
    labelEn: 'Patient-Centered Care',
    labelEs: 'Atención centrada en el paciente'
  }, {
    icon: BookOpen,
    labelEn: 'Evidence-Based Approach',
    labelEs: 'Enfoque basado en evidencia'
  }];
  return <section className="bg-[#0f172a] border-b border-slate-800 py-10" data-id="element-218">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-219">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-220">
          {badges.map((badge, index) => <div key={index} className="flex flex-col items-center text-center space-y-3 py-4" data-id="element-221">
              <div className="bg-[#0d9488]/10 border border-[#0d9488]/30 p-4 rounded-full" data-id="element-222">
                <badge.icon className="w-7 h-7 text-[#0d9488]" data-id="element-223" />
              </div>
              <span className="text-sm font-semibold text-slate-200 tracking-wide uppercase" data-id="element-224">
                {t(badge.labelEn, badge.labelEs)}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}